<div id="goOnlineSyncContainer" class="sync-container" [ngClass]="{'display-grid': !syncWithError}">
  <div class="logos-container">
    <div id="snaponLogoContainer" class="logo-container">
      <div id="snaponLogo" class="crm-industrial-font icon-snapon-logo"></div>
    </div>
    <div id="impactLogoContainer" class="logo-container">
      <div id="impactLogo" class="impact-logo">
        <app-icon id="impact-logo" [icon]="appIcon"></app-icon>
      </div>
    </div>
  </div>

  @if (!syncWithError) {
    <div id="progressContainer" class="progress-container">
      <div id="stepProgress" class="step-progress">
        {{appStrings.stepLabel}}{{syncStepIndex+1}} : {{syncStep}}
      </div>
      <div id="loadingStepper" class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div id="stepsDetails" class="stepsDetails-container">
        @for (step of syncStepsProgress; track step; let index = $index) {
          <div class="sync-element-details">
            <div [id]="'syncStep_'+index" class="sync-step-details-container">
              @if (step.inProgress) {
                <span [id]="'stepInProgressIcon_'+index" class="circle-container">
                  <span class="empty-circle"></span>
                </span>
              }
              @if (step.done) {
                <span [id]="'stepDoneIcon_'+index" class="circle-container red-circle-container">
                  <span class="crm-industrial-font icon-checked"></span>
                </span>
              }
              <span [id]="'syncStepName_'+index" class="step-value"
                [ngClass]="{'red-step-value': step.done, 'disabled': !step.done && !step.inProgress, 'go-offline-step-value': syncFor.goOffline}">
                {{step.key}}
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (syncWithError) {
    <div id="syncErrorContainer" class="progress-container">
      <div id="errorMessage" class="step-progress sync-error-message">
        <div class="text-container">
          <app-icon id="unsuccessfullySyncIcon" class="unsuccessfully-sync-icon" [icon]="unsuccessfullySyncIcon">
          </app-icon>
          <span class="error-message">{{appStrings.goOnline_syncWithError}}</span>
        </div>
        <div class="buttons-container">
          <button id="retryButton" class="button primary" mat-button (click)="retry()">
            <span class="crm-industrial-font icon-refresh"></span>
            {{appStrings.button_retry}}
          </button>
          <button id="cancelButton" class="button" mat-button (click)="cancel()">
            {{appStrings.button_cancel}}
          </button>
        </div>
      </div>
    </div>
  }
</div>